import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatWeBuildSection } from "@/components/sections/WhatWeBuildSection";
import { CTASection } from "@/components/sections/CTASection";

const WhatWeBuild = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <WhatWeBuildSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default WhatWeBuild;
